import { Location } from "gen/company/models_pb"
import { useIdFilter } from "shared-ts/hooks/useFilter"

import { useListLocationsForCompanyQuery } from "features/api/company"
import { useWebFilter, UseWebFilterProps } from "hooks/filters/useWebFilter"

export function useLocationFilter({
  persistInUrl = true,
  key = "location",
  label = "Location",
  initialSelectedOptions = [],
  allowExternalValues = false,
  filterActive = true,
}: Partial<
  Pick<
    UseWebFilterProps<unknown>,
    | "persistInUrl"
    | "key"
    | "label"
    | "initialSelectedOptions"
    | "allowExternalValues"
  >
> & { filterActive?: boolean } = {}) {
  const { data } = useListLocationsForCompanyQuery({ filterActive })

  const { filter, selected: selectedLocationIds } = useIdFilter({
    key,
    label,
    values: data?.locations ?? [],
    allowExternalValues,
    labelExtractor: (location: Location) =>
      !location.isActive ? `${location.name} - Inactive` : location.name,
    useFilter: (props) =>
      useWebFilter({
        ...props,
        persistInUrl,
        initialSelectedOptions,
      }),
  })

  return { filter, selectedLocationIds }
}
